/**
 * Redux store — single source of truth for client state.
 *
 * Add new slices here when needed. Server data does NOT go in Redux;
 * use TanStack Query for that.
 */

import { configureStore } from '@reduxjs/toolkit';

import authReducer from './authSlice';
import uiReducer from './uiSlice';
import clinicReducer from './clinicSlice';
import cartReducer from './cartSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    clinic: clinicReducer,
    cart: cartReducer,
  },
  // Default middleware includes thunk + immutability checks + serializability checks
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Add ignore paths here if you ever store non-serializable values
      serializableCheck: true,
    }),
  devTools: import.meta.env.DEV,
});

/** Useful for backend developers reading the code — these are the available state shapes */
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
